import storefront from "../../global/storefront";
import unwrapNodes from "../unwrapNodes";
import addProductHelpers from "../addProductHelpers";
import getBuyer from "../getBuyer";
import { monogramComponentByHandle } from "../../global/storefront/queries";

const cache = {};

export default function fetchMonogram(handle) {
  if (handle in cache) {
    return cache[handle];
  }

  cache[handle] = getBuyer()
    .then((buyer) =>
      storefront.request({
        query: monogramComponentByHandle,
        variables: {
          handle: { handle, type: "monogram_component" },
          buyer,
        },
      }),
    )
    .then(({ data }) => {
      const output = unwrapNodes(data.metaobject);

      if (output) {
        // The nested monogram product is a full product query — give it the
        // same helpers/price accessors as a top-level product.
        if (output.monogramProduct) {
          addProductHelpers(output.monogramProduct);
        }

        // Colors live on a separate global `monogram_colors` metaobject,
        // fetched as a sibling root field in the same query.
        output.monogramColors = unwrapNodes(data.monogramColors)?.colors ?? [];
      }

      return output;
    });

  return cache[handle];
}
